import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const r = l((i, a) => /* @__PURE__ */ s.jsx(
  e,
  {
    ref: a,
    ...i,
    image: (c) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...c,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4156)", children: [
            /* @__PURE__ */ s.jsx(
              "mask",
              {
                id: "mask0_2974_4156",
                width: 32,
                height: 33,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M39.36 29.3c-.4-.06-.79.22-.85.63-.86 5.64-3.12 9.57-5.51 9.57-2.84 0-5.87-5.83-5.87-14.5S30.16 10.5 33 10.5c2.37 0 4.63 3.9 5.5 9.49.06.41.45.69.86.63s.69-.45.63-.86C38.97 13.22 36.23 9 33 9c-4.13 0-7.37 7.03-7.37 16S28.87 41 33 41c3.25 0 5.99-4.26 6.99-10.85a.747.747 0 0 0-.63-.85M14.79 18.21a.761.761 0 0 0 1.16 0l6.62-7.98c.26-.32.22-.79-.1-1.06a.76.76 0 0 0-1.06.1l-6.04 7.28-6.04-7.28a.757.757 0 0 0-1.06-.1c-.32.26-.36.74-.1 1.06zM15.37 20.26c-.41 0-.75.34-.75.75v7.98c0 .41.34.75.75.75s.75-.34.75-.75v-7.98c0-.41-.33-.75-.75-.75M21.99 31.52H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h5.87v7.23c0 .41.34.75.75.75s.75-.34.75-.75v-7.23h5.87a.749.749 0 1 0 0-1.5"
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4156)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0-.051h48v48.232H0z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4156", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "AgencyVitaminCIcon";
export {
  r as AgencyVitaminCIcon,
  r as default
};
//# sourceMappingURL=index.js.map
